import { render, staticRenderFns } from "./typeItemsList.vue?vue&type=template&id=7d00233c&scoped=true&"
import script from "./typeItemsList.vue?vue&type=script&lang=js&"
export * from "./typeItemsList.vue?vue&type=script&lang=js&"
import style0 from "./typeItemsList.vue?vue&type=style&index=0&id=7d00233c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d00233c",
  null
  
)

export default component.exports